// extracted by mini-css-extract-plugin
export default {"iconWrapper":"iconWrapper--qfw7XLphiRtqwNP","icon":"icon--Qg4YoKuCsw36ep9"};